const HoneyPot = () => {
    return (
        <a
            href="/v1/lot/"
            // @ts-ignore
            style={{ ariaHidden: 'true', display: 'none' }}
        >
            lots of lots
        </a>
    );
};

export default HoneyPot;
